import { ConfigProvider, FloatButton, Layout, Skeleton, Space } from "antd";
import { MainLayout } from "components/layouts";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as ExpenseIcon } from "assets/icon/expenseIconCustom.svg";

function Employee() {
  const location = useLocation()
  const navigate = useNavigate()

  const show = useMemo(() => {
    return location?.state?.selectedTab ? "inline" : "none"
  }, [location?.state?.selectedTab])


  return <div>
    <ConfigProvider
      theme={{
        token: {
          colorBgElevated: "var(--button-color)",
          colorFillContent: "white"
        },
      }}
    >
      <FloatButton style={{ display: show, lineHeight: "0", fontSize: "2em", width: "5em" }} shape="square" description={
        <Space style={{ paddingTop: 5, }} > <ExpenseIcon /><p style={{ fontSize: "1.3em" }}>{`ทำเงินเดือน`}</p></Space>
      } onClick={() => navigate(`${location?.state?.selectedTab}`)} />
    </ConfigProvider>

    <Outlet />
  </div>;
}

export default Employee;
